function formatMoney(cents) {
  const amount = cents / 100;

  const format =
    (window.theme && window.theme.moneyFormat) ||
    (window.Shopify && window.Shopify.money_format) ||
    '${{amount}}';

  return format.replace('{{amount}}', amount.toFixed(2));
}


if (!customElements.get("variant-options")) {
  customElements.define(
    "variant-options",
    class VariantOptions extends HTMLElement {
      whenLoaded = Promise.all([customElements.whenDefined("gallery-section")]);
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.addEventListener("keydown", this.onKeyDown);

        this.container = document.querySelector(
          `section[data-product-handle="${this.getAttribute("data-product-handle")}"]`,
        );
      }

      connectedCallback() {
        this.whenLoaded.then(() => {
          this.initialize();

        
          this.updateMasterId();
          this.updatePriceFromVariant();
        });
      }

      disconnectedCallback() {}

      initialize() {
        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();
        this.updateVariantStatuses();
      }

      onKeyDown(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
          const input = event.target.querySelector("input");
          input?.click();
          // this.onVariantChange();
        }
      }

      onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantStatuses();
        this.updateVariantInput();

        if (!this.currentVariant) {
          this.setUnavailable();
          return;
        }

        this.updateMedia();

        
        this.updatePriceFromVariant();
      }


      updateGallery() {
        const mediaGallery = document.getElementById(
          `MediaGallery-${this.dataset.section}`,
        );

        let media_id = false;
        if (this.currentVariant && this.currentVariant.featured_media) {
          media_id = this.currentVariant.featured_media.id;
        }

        mediaGallery?.filterSlides(this.options, media_id, true);
      }

      updateOptions() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          )?.value;
        });

        fieldsets.forEach((fieldset, index) => {
          const selectedOption = this.options[index];
          fieldset.querySelector(
            ".wt-product__option__title .value",
          ).innerHTML = selectedOption;
          const dropdown = fieldset.querySelector(
            ".wt-product__option__dropdown span",
          );
          if (dropdown) dropdown.innerHTML = selectedOption;
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData()?.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateMedia() {
        if (!this.currentVariant) return;
        this.setAttribute("data-variant-id", this.currentVariant?.id);
        if (!this.currentVariant.featured_media) return;
        this.setAttribute(
          "data-featured-image",
          this.currentVariant?.featured_media?.preview_image?.src,
        );
        this.setAttribute(
          "data-featured-image-id",
          this.currentVariant?.featured_media?.id,
        );

        const modalContent = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`,
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`,
        );
        modalContent.prepend(newMediaModal);
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateShareUrl() {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}`,
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }



      // updatePriceFromVariant() {
      //   if (!this.currentVariant) return;

      //   const el = document.querySelector('.custom-product-price');
      //   if (!el) {
      //     console.warn('.custom-product-price NOT FOUND');
      //     return;
      //   }

      //   // Use your custom formatter instead of Shopify.formatMoney
      //   el.textContent = formatMoney(this.currentVariant.price);
      // }
      updatePriceFromVariant() {
        if (!this.currentVariant) return;

        const section =
          this.closest("section[data-section-id]") ||
          this.container ||
          document;

        // 1) PDP custom price node (your theme's real price on product page)
        const pdpPrice = section.querySelector(".custom-product-price");
        if (pdpPrice) {
          pdpPrice.textContent = formatMoney(this.currentVariant.price);

          // unit price right next to it
          const row =
            pdpPrice.closest(".custom-title-price-row") || pdpPrice.parentElement;

          if (row) {
            let unitEl = row.querySelector(".custom-unit-price");

            const upm = this.currentVariant.unit_price_measurement;
            const unitPrice = this.currentVariant.unit_price;

            if (unitPrice && upm) {
              const refVal =
                upm.reference_value && upm.reference_value !== 1
                  ? `${upm.reference_value} `
                  : "";

              const text = `(${formatMoney(unitPrice)} / ${refVal}${upm.reference_unit})`;

              if (!unitEl) {
                unitEl = document.createElement("span");
                unitEl.className = "custom-unit-price";
                // place it after the price
                pdpPrice.parentElement.appendChild(unitEl);
              }

              unitEl.textContent = ` ${text}`;
              unitEl.style.display = "";
            } else if (unitEl) {
              unitEl.textContent = "";
              unitEl.style.display = "none";
            }
          }

          // Since PDP price is handled, we can return early.
          return;
        }

        // 2) Fallback: theme price snippet areas (cards, upsells, etc.)
        const priceWrap =
          section.querySelector("[data-product-price]") ||
          section.querySelector(`#price-${this.dataset.section}`);

        if (!priceWrap) return;

        priceWrap.querySelectorAll(".wt-money").forEach((node) => {
          node.textContent = formatMoney(this.currentVariant.price);
        });

        const unitInlineNodes = priceWrap.querySelectorAll(".wt-unit-inline");
        const upm = this.currentVariant.unit_price_measurement;
        const unitPrice = this.currentVariant.unit_price;

        if (unitPrice && upm) {
          const refVal =
            upm.reference_value && upm.reference_value !== 1
              ? `${upm.reference_value} `
              : "";

          const text = ` (${formatMoney(unitPrice)} / ${refVal}${upm.reference_unit})`;

          unitInlineNodes.forEach((n) => {
            n.textContent = text;
            n.classList.remove("hidden");
            n.style.display = "";
          });
        } else {
          unitInlineNodes.forEach((n) => {
            n.textContent = "";
            n.classList.add("hidden");
            n.style.display = "none";
          });
        }
      }

      


      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateVariantStatuses() {
        // const selectedOptionOneVariants = this.variantData.filter(
        //   (variant) => this.querySelector(':checked').value === variant.option1
        //   );
        const selectedOptionOneVariants = this.variantData?.filter(
          (variant) => variant.available === true,
        );
        const inputWrappers = [
          ...this.querySelectorAll(".product-form__input"),
        ];
        inputWrappers.forEach((option, index) => {
          if (index === 0 && this.currentVariant?.options.length > 1) return;
          const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
          ];
          const previousOptionSelected =
            inputWrappers[index - 1]?.querySelector(":checked")?.value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter(
              (variant) =>
                variant.available &&
                variant[`option${index}`] === previousOptionSelected,
            )
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
          if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.classList.remove("disabled");
          } else {
            input.classList.add("disabled");
          }
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
          "pickup-availability",
        );
        if (!pickUpAvailability) return;

        pickUpAvailability.dataset.variantId = this.currentVariant?.id;
        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        try {
          productForm?.handleErrorMessage();
        } catch (err) {
          console.log(err);
        }
      }

      

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        const button = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent,
          );
        return this.variantData;
      }
    },
  );
}
// customElements.define('variant-options', VariantOptions);
